enum AssetContentFormat {
    Png = "png",
    Svg = "svg",
    Jpg = "jpg",
    Pdf = "pdf",
    Webp = "webp",
    Avif = "avif"
}

enum AssetOptimizationStatus {
    Queued = "queued",
    Processing = "processing",
    Ready = "ready",
    Error = "error"
}

interface AssetContent {
    _id: string;
    url: string;
    format: AssetContentFormat;
    density?: string;
    densityScale?: number;
    optimized?: boolean;
    originalURL?: string;
    status?: AssetOptimizationStatus;
    percent?: number;
    originalContentId?: string;
}

interface ApiAsset {
    _id: string;
    layerId: string;
    layerName: string;
    displayName: string;
    autoExported?: boolean;
    contents: AssetContent[];
}

export default ApiAsset;
export {
    AssetContentFormat,
    AssetContent,
    AssetOptimizationStatus
};
